export const initialState = {
    items: null,
    isLoading: false,
    error: null,
};
